import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './plugins/element.js'
import './plugins/dashboard-components.js'
import './assets/flex.css'
import './assets/style.scss'
import './request.js'
Vue.config.productionTip = false

export default new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')
